import $ from 'jquery';

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {
    PARENT: '.js-checkBoxDependencies-parent',
    CHILD: '.js-checkBoxDependencies-child',
    MESSAGE_UPDATE: '.js-checkBoxDependencies-child-update'
};

// const MESSAGES = {
//     AUTO_CHECKING: ': checking this checkbox has automatically checked and disabled the following checkboxes: ',
//     AUTO_UNCHECKING: ': unchecking this checkbox has automatically re-enabled the following checkboxes: '
// }

/**
 * Checks and disables dependent checkbox 
 * fields when the parent is clicked.
 *
 * @class CheckboxDependenciesView
 * @constructor
 */
export default class CheckboxDependenciesView {
    constructor($element) {
        this.$element = $element;
        return this.setupHandlers()
            .createChildren()
            .enable();
    }

    /**
     * SetupHandlers
     *
     * @method setupHandlers
     * @public
     * @chainable
     */
    setupHandlers() {
        this.onParentClickHandler = this.onParentClick.bind(this);
        return this;
    }

    /**
     * createChildren
     *
     * @method createChildren
     * @public
     * @chainable
     */
    createChildren() {
        this.$parent = this.$element.find(SELECTORS.PARENT);
        this.$children = this.$element.find(SELECTORS.CHILD);
        this.$screenReaderUpdate = this.$element.find(SELECTORS.MESSAGE_UPDATE);
        return this;
    }

    /**
     * Automatically checks child checkboxes
     * when a user clicks parent checkbox
     *
     * @method onParentClick
     * @public
     * @chainable
     */
    onParentClick(e) {
        let childFieldLabels = '';
        if (this.$parent[0].checked) {

            for (let i = 0; i < this.$children.length; i++) {
                this.$children[i].checked = true;
                this.$children[i].setAttribute('onclick', 'return false');
                this.$children[i].setAttribute('readonly', '');
                this.$children[i].setAttribute('aria-disabled', 'true');
                childFieldLabels += this.$children[i].labels[0].innerText + ', ';
            }
            let updateText = this.$parent[0].labels[0].innerText + MESSAGES.AUTO_CHECKING + childFieldLabels;
            setTimeout(() => {
                this.$screenReaderUpdate.text(updateText);
            }, 500);
        } else {
            for (let i = 0; i < this.$children.length; i++) {
                this.$children[i].removeAttribute('onclick');
                this.$children[i].removeAttribute('readonly');
                this.$children[i].removeAttribute('aria-disabled');
                childFieldLabels += this.$children[i].labels[0].innerText + ', ';
            }
            let updateText = this.$parent[0].labels[0].innerText + MESSAGES.AUTO_UNCHECKING + childFieldLabels;
            setTimeout(() => {
                this.$screenReaderUpdate.text(updateText);
            }, 500);
        }

        return this;
    }

    /**
     * Enable
     *
     * @method enable
     * @public
     * @chainable
     */
    enable() {
        this.$parent.on('click', this.onParentClickHandler);
        return this;
    }

    /**
     * Disable
     *
     * @method disable
     * @public
     * @chainable
     */
    disable() {
        this.$parent.off('click', this.onParentClickHandler);
        return this;
    }
}